import { render, staticRenderFns } from "./InvestorsListing.vue?vue&type=template&id=f57be4cc"
import script from "./InvestorsListing.vue?vue&type=script&lang=js"
export * from "./InvestorsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports